//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { completeNewPassword } from "@/utils/auth.js";
import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  name: "ResetPasswordView",
  created() {
    this.username = this.$route.query.username;
  },
  data() {
    return {
      valid: false,
      password: "",
      passwordConfirm: "",
      username: "",
      acceptConditions: false,
      showCondicionesGeneralesModel: false
    };
  },
  computed: {
    passwordRules() {
      return {
        required: value => !!value || "Obligatorio",
        min: v => v.length >= 8 || "Mínimo 8 caracteres",
        passwordMatch: () => "El usuario o contraseña no es correcto",
        regex: v =>
          /^(?=.*\d)(?=.+[a-z])(?=.*[A-Z])[0-9a-zA-Z_$&+,:;=?@#|'<>.^*()%!-]{8,}$/.test(
            v
          ) || "Debe una minúscula, una mayúscula y un número"
      };
    },
    ...mapGetters([
      "getUser"
      // ...
    ])
  },
  methods: {
    showCondicionesGenerales() {
      console.log("Mostramos las condiciones genreales");
      if (this.acceptConditions) {
        this.acceptConditions = false;
      } else {
        this.showCondicionesGeneralesModel = true;
      }
    },
    async submit() {
      if (this.acceptConditions !== true) {
        this.$q.notify({
          position: "top-right",
          message: "Debe aceptar las condiciones",
          color: "negative"
        });
        return;
      }
      let success = await this.$refs.form.validate();
      if (success) {
        if (this.password !== this.passwordConfirm) {
          this.$q.notify({
            position: "top-right",
            message: "Las contraseñas no coinciden",
            color: "negative"
          });
          return;
        }
        console.log(
          `Restableciendo contrasenia: passwordConfirm: ${this.passwordConfirm}, password: ${this.password}`
        );
        try {
          this.$q.loading.show({
            message: "Iniciando usuario..."
          });
          await completeNewPassword(this.getUser, this.password);
        } catch (error) {
          this.$q.notify({
            position: "top-right",
            message: "Sesión expirada. Vuelva a introducir el login",
            color: "negative"
          });
          AmplifyEventBus.$emit("authState", "signedOut");
        } finally {
          this.$q.loading.hide();
        }
      } else {
        console.error(`Modelo no correcto`);
      }
    }
  }
};
